import api from '@/api'

export default {
    install(Vue) {
        Vue.config.globalProperties.$api = api
    }

}